import { render, staticRenderFns } from "./PeriodSummary.vue?vue&type=template&id=ec617c16&scoped=true"
import script from "./PeriodSummary.vue?vue&type=script&lang=js"
export * from "./PeriodSummary.vue?vue&type=script&lang=js"
import style0 from "./PeriodSummary.vue?vue&type=style&index=0&id=ec617c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec617c16",
  null
  
)

export default component.exports